import React, { useState } from "react";
import { StyledManageOrganizationChart } from "./ManageOrganizationChart.styled";
import { StyledManagementFooter } from "../../Components/Footer/ManagementFooter.styled";
import { ReactComponent as SaveIcon } from "../../../../icons/save.svg";
import { Button } from "../../../../components/core/Button/Button";
import { SAVE_LABEL } from "../../../../constants/Dictionary";
import { FileUploader } from "../../../../components/core/UploadFile/FileUploader";
import { FileUploaderSizeEnum } from "../../../../types/AppTypes";

export const ManageOrganizationChart = () => {
  const [file, setFile] = useState<File | null>(null);

  return (
    <StyledManageOrganizationChart>
      <div className="content-container">
        <FileUploader
          size={FileUploaderSizeEnum.LARGE}
          value={file}
          onFileUpload={setFile}
        />
      </div>
      <div className="footer-container">
        <StyledManagementFooter>
          <Button label={SAVE_LABEL} icon={<SaveIcon />} />
        </StyledManagementFooter>
      </div>
    </StyledManageOrganizationChart>
  );
};
